<md-content-box class="timeline-v2" padding="xl">
	@if (loadingRelatedLessons()) {
		<lb-loader></lb-loader>
	} @else {
		<div class="timeline-v2__legend-row">
			@if (timelineHasSemesters()) {
				<md-button-group class="timeline-v2__semester-tabs" [value]="activeSemesterKey()" (change)="onSemesterTabChange($event)">
					@for (group of semesterGroups(); track group.key) {
						<md-button-toggle [value]="group.key">
							{{ group.label ?? 'Semester' }}{{ group.key === 'none' ? ' (' + group.items.length + ')' : '' }}
						</md-button-toggle>
					}
				</md-button-group>
			}

			<div class="timeline-v2__legend-spacer"></div>

			<button md-button (click)="openLegend()">Key</button>
		</div>

		@if (activeSemesterGroup(); as group) {
			@if (isNeedsReview()) {
				<div class="timeline-v2__review-list">
					@for (item of group.items; track item.lesson.lessonID) {
						<md-content-box type="warning" class="timeline-v2__review-card" (click)="selectLesson(item.lesson.lessonID)">
							<div class="review-card__status">
								<md-icon icon="untitled-ui/alerts/alert-triangle" class="review-card__status-icon"></md-icon>
								<span class="review-card__status-text">{{ item.label }} {{ item.time }}</span>
							</div>
							<div class="review-card__body">
								<md-tag type="warning">{{ getReviewReason(item.lesson) }}</md-tag>
								<md-tag type="tertiary">{{ item.lesson.lessonTypeName }}</md-tag>
								<span class="review-card__date">{{ item.label }}</span>
							</div>
						</md-content-box>
					}
				</div>
			} @else {
				<div class="timeline-v2__track-wrap" #trackWrap>
					<div class="timeline-v2__items">
						@for (item of group.items; track item.lesson.lessonID) {
							<div class="timeline-v2-item" [class.timeline-v2-item--current]="item.isCurrent">
								<div class="timeline-v2-item__item-header">
									@if (item.showDateLabel) {
										<span class="timeline-v2-item__date-label">{{ item.label }}</span>
									}
								</div>
								<div class="timeline-v2-item__dot-wrap">
									<button
										type="button"
										class="timeline-v2-item__dot"
										[class.timeline-v2-item__dot--warning]="item.status === 'warning'"
										[class.timeline-v2-item__dot--attention]="item.status === 'attention'"
										[class.timeline-v2-item__dot--current]="item.isCurrent"
										[class.timeline-v2-item__dot--current-absent]="item.isCurrent && item.status === 'absent'"
										[class.timeline-v2-item__dot--today-next]="item.isTodayOrNext"
										(click)="selectLesson(item.lesson.lessonID)"
										[md-tooltip]="item.tooltip"
										md-tooltip-position="top"
									>
										@if (item.isTodayOrNext) {
											<md-icon icon="untitled-ui/maps/marker-pin-01"></md-icon>
										} @else {
											<md-icon
												[icon]="item.statusIcon"
												[class.timeline-v2-item__dot-icon--completed]="item.status === 'completed'"
												[class.timeline-v2-item__dot-icon--absent]="item.status === 'absent'"
											></md-icon>
										}
									</button>
								</div>

								<button type="button" class="timeline-v2-item__lesson-chip" (click)="selectLesson(item.lesson.lessonID)">
									<md-icon [icon]="item.lessonTypeIcon" [md-tooltip]="item.lesson.lessonTypeName" md-tooltip-position="top"></md-icon>
									@if (item.number) {
										<span>{{ item.number | number: '1.0' }}</span>
									} @else if (item.status === 'absent') {
										<span>Absent</span>
									}
								</button>

								@if (item.lesson.semesterLessonTypeID && getSemesterLessonTypeIcon(item.lesson.semesterLessonTypeID) !== null) {
									<div class="timeline-v2-item__semester-milestone">
										<md-icon
											[icon]="getSemesterLessonTypeIcon(item.lesson.semesterLessonTypeID)!"
											class="timeline-v2-item__semester-type-icon"
											[md-tooltip]="item.lesson.semesterLessonTypeName ?? 'Semester milestone'"
											md-tooltip-position="top"
										></md-icon>
									</div>
								}
							</div>
						}
					</div>
				</div>
			}
		} @else {
			<span class="timeline-v2__empty">No lessons found.</span>
		}
	}
</md-content-box>
